import { createSlice } from "@reduxjs/toolkit";
import { WeAreAvailableAPI } from "../../services/we-are-available";

const WeAreAvailable = createSlice({
  name: "We are available",
  initialState: {
    weAreAvailable: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(WeAreAvailableAPI.get.fulfilled, (state, action) => {
      state.weAreAvailable = Array.isArray(action.payload)
        ? null
        : action.payload;
    });
  },
});

export default WeAreAvailable;
